<template>
  <organism-ticket-topic-management
    :fields="ticketTopicTableHeader"
    :items="ticketTopicTableData"
    @onSendRequestToCreateTicketTopic="onSendRequestToCreateTicketTopic"
    @onSendRequestToUpdateTicketTopic="onSendRequestToUpdateTicketTopic"
  ></organism-ticket-topic-management>
</template>

<script>
import OrganismTicketTopicManagement from "@/components/organisms/globalSetting/dataManagement/ticket/OrganismTicketTopicManagement.vue"
import mixins from "@/mixins"

import {
  getTopicList,
  createNewTicketTopic,
  updateTicketTopic,
} from "@/api/api-module1"

export default {
  name: "TicketTopicDataManagement",

  mixins: [mixins],

  components: {
    OrganismTicketTopicManagement,
  },

  data() {
    return {
      ticketTopicTableHeader: [
        {
          key: "index",
          label: "#",
          thClass: "w-50px",
          tdClass: "w-50px",
        },
        {
          key: "topicName",
          label: "TICKET TOPIC NAME",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "topicSubject",
          label: "TICKET SUBJECT",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
      ],
      ticketTopicTableData: [],
    }
  },

  mounted() {
    this.fetchDataFromApi()
  },

  methods: {
    async fetchDataFromApi() {
      this.showLoading(true)
      await getTopicList()
        .then((response) => {
          this.ticketTopicTableData = response.map((topic, index) => {
            return {
              index: index + 1,
              topicId: topic.topicId,
              topicName: topic.topicName,
              topicSubject: topic.topicSubject,
              topicDetail: topic.topicDetail,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    async onSendRequestToCreateTicketTopic(newTicketTopic) {
      this.showLoading(true)
      await createNewTicketTopic(newTicketTopic)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Created Ticket Topic Successfully")
            await this.fetchDataFromApi()
          }
        })
        .catch(() => {
          this.toastError("Create Ticket Topic Failed")
        })
        .finally(() => this.showLoading(false))
    },

    async onSendRequestToUpdateTicketTopic(editedTicketTopic) {
      const request = {
        topicName: editedTicketTopic.topicName,
        topicSubject: editedTicketTopic.topicSubject,
        topicDetail: editedTicketTopic.topicDetail,
      }
      this.showLoading(true)
      await updateTicketTopic(editedTicketTopic.topicId, request)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Updated Ticket Topic Successfully")
            await this.fetchDataFromApi()
          }
        })
        .catch(() => {
          this.toastError("Update Ticket Topic Failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
